exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n\r\n\r\n.report-create-free-ac .create-free-ac-detail { float: left; width: 60%; }\r\n.report-create-free-ac .create-free-ac-img { float: left; width: 40%; }\r\n.report-create-free-ac .create-free-ac-detail h4 { font-size: 50px; color:#143b50; font-family: 'Montserrat'; }\r\n.report-create-free-ac .create-free-ac-detail .btn-free-ac button { display: block; border: 0 none; background: #2F79EB; color: #fff; font-size: 22px; text-transform: uppercase;\r\n  padding: 8px 30px; border-radius: 12px; box-shadow: 0px 3px 4px #b5b5b5; font-family: 'Montserrat'; width: 100%; transition: .35s ease-in-out;}\r\n.report-create-free-ac .create-free-ac-detail .btn-free-ac button:hover { background: #1150ae; }\r\n.report-create-free-ac .create-free-ac-detail .btn-free-ac { text-align: center; margin-top: 60px;}\r\n.report-create-free-ac .create-free-ac-detail .btn-free-ac span { margin-top: 10px; display: block; font-size: 14px; color: #767676; font-family: 'Montserrat';}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/session-length/session-length.component.css
// module id = ../../../../../src/app/reports/myReports/session-length/session-length.component.css
// module chunks = main